import FileService from '@/api/FileService'

// initial state
const state = {

}

// getters
const getters = {

}

// mutations
const mutations = {

}

// actions
const actions = {
  async uploadImage ({ commit }, data) {
    var result = null
    try {
      // clear error
      this.dispatch('Error', null)

      let response = await FileService.uploadImage(data)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteImage ({ commit }, data) {
    var result = null
    try {
      // clear error
      this.dispatch('Error', null)

      let response = await FileService.deleteImage(data)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/File.js